import type { GeocodingFeature } from '@mapbox/search-js-core/dist/geocode/types';

import { publicConfig } from '@public-config';

export type { GeocodingFeature };
export type Geo = GeocodingFeature['properties'];

const GeoService = {
    geocode: async (query: string) => {
        const params = new URLSearchParams({
            access_token: publicConfig.mapboxPublicKey ?? '',
            q: query,
        });

        const response = await fetch(`https://api.mapbox.com/search/geocode/v6/forward?${params.toString()}`);
        const json = await response.json();

        return ((json.features || [])[0]?.properties || null) as Geo | null;
    },
};

export { GeoService };
